<template>
  <div v-if="!isAuthenticated">
    <AmplifyLogin />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store"
import AuthService from "@/common/auth.service"

export default {
  name: "Login",
  components: {
    AmplifyLogin: () => import("@/components/Login/Login"),
  },
  computed: {
    ...mapGetters(["isAuthenticated", "getAvailableOrganisation"]),
  },
  mounted() {
    AuthService.Token.then(response => {
      if (response != null) {
        this.$router.push('/home');
      }
    })
  }
};
</script>
<style  lang="scss">
#loginLogo {
  display: block;
  max-width: 230px;
  max-height: 95px;
  width: auto;
  height: auto;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

#loginCardContainer {
  width: 350px;
  padding: 20px;
}
</style>
